export default __webpack_public_path__ + "static/media/brand5.c8b6ad8a.svg";